module.exports = __webpack_public_path__ + "img/zixun1.fee29b92.png";